import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output } from "@angular/core";
import { AjaxService } from "src/app/service/ajax.service";
import { UtilService } from "src/app/service/util.service";
import { API } from "src/environments/environment";

@Component({
  selector: "app-modal-configuracao-triagem",
  templateUrl: "./modal-configuracao-triagem.component.html",
  styleUrls: ["./modal-configuracao-triagem.component.scss"],
})
export class ModalConfiguracaoTriagemComponent implements OnInit, OnChanges {
  @Input() item: any;
  @Output() acaoVoltar = new EventEmitter();

  public triagemItem: any;
  public arrayTipoClassificacao: any[];

  constructor(private ajax: AjaxService, public util: UtilService) {}

  ngOnInit() {
    this.limpar();
    if (this.item) {
      this.preencheTriagemEdit(this.item);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item'] && changes['item'].currentValue) {
      this.preencheTriagemEdit(changes['item'].currentValue);
    }
  }

  preencheTriagemEdit(item) {
    console.log("preencheTriagemEdit - item recebido:", item);
    if (item != null) {
      this.triagemItem = item;
      console.log("ID_TRIAGEM:", this.triagemItem.iD_TRIAGEM);
      this.buscarTipoClassificacao();
    } else {
      this.limpar();
    }
  }

  buscarTipoClassificacao() {
    console.log("buscarTipoClassificacao - triagemItem:", this.triagemItem);
    if (this.triagemItem && this.triagemItem.iD_TRIAGEM) {
      this.util.showLoading();
      let url = API + "CampoFormularioTriagem/CampoFormularioTriagem/ConsultarTipoClassificacaoPorTriagem/" + this.triagemItem.iD_TRIAGEM;
      console.log("URL da chamada:", url);
      this.ajax.get(url).subscribe(
        (response) => {
          console.log("Resposta da API:", response);
          let dados = response.data || [];
          // Remove itens com quantidade zero
          this.arrayTipoClassificacao = dados.filter(item => item.qtd > 0);
          this.util.closeLoading();
          // Após buscar os tipos, busca os parâmetros salvos
          this.buscarParametrosSalvos();
        },
        (err) => {
          console.error("Erro na chamada:", err);
          debugger;
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Buscar Tipo Classificação");
        }
      );
    } else {
      console.warn("TriagemItem ou ID_TRIAGEM não encontrado");
    }
  }

  buscarParametrosSalvos() {
    if (!this.triagemItem || !this.triagemItem.iD_TRIAGEM) {
      return;
    }

    this.util.showLoading();
    let url = API + "TriagemParametro/TriagemParametro/ConsultarPorTriagem/" + this.triagemItem.iD_TRIAGEM;
    console.log("URL buscar parâmetros:", url);
    this.ajax.get(url).subscribe(
      (response) => {
        console.log("Resposta parâmetros salvos:", response);
        let parametrosSalvos = response.data || [];
        
        // Preenche os valores na tabela fazendo match pelo iD_TIPO_CLASSIFICACAO_PERGUNTA
        if (this.arrayTipoClassificacao && parametrosSalvos.length > 0) {
          this.arrayTipoClassificacao.forEach(itemTabela => {
            let parametroEncontrado = parametrosSalvos.find(param => 
              param.iD_TIPO_CLASSIFICACAO_PERGUNTA === itemTabela.iD_TIPO_CLASSIFICACAO_PERGUNTA ||
              param.iD_TIPO_CLASSIFICACAO_PERGUNTA === itemTabela.id
            );
            
            if (parametroEncontrado) {
              itemTabela.valor = parametroEncontrado.valor;
              itemTabela.iD_TRIAGEM_PARAMETRO = parametroEncontrado.iD_TRIAGEM_PARAMETRO;
              itemTabela.iD_TIPO_CLASSIFICACAO_PERGUNTA = parametroEncontrado.iD_TIPO_CLASSIFICACAO_PERGUNTA;
            }
          });
        }
        
        this.util.closeLoading();
      },
      (err) => {
        console.error("Erro ao buscar parâmetros:", err);
        this.util.closeLoading();
        // Não mostra erro, pois pode ser que não existam parâmetros salvos ainda
      }
    );
  }

  limpar() {
    this.triagemItem = null;
    this.arrayTipoClassificacao = [];
  }

  voltar() {
    this.limpar();
    this.acaoVoltar.emit();
  }

  inicializar(item: any) {
    console.log("inicializar chamado com item:", item);
    if (item) {
      this.preencheTriagemEdit(item);
    }
  }

  montarJsonSalvar() {
    if (!this.arrayTipoClassificacao || this.arrayTipoClassificacao.length === 0) {
      return [];
    }

    return this.arrayTipoClassificacao.map(item => ({
      valor: item.valor || 0,
      iD_TIPO_CLASSIFICACAO_PERGUNTA: item.iD_TIPO_CLASSIFICACAO_PERGUNTA || item.id || 0,
      iD_TRIAGEM: this.triagemItem?.iD_TRIAGEM || 0
    }));
  }

  salvar() {
    if (!this.triagemItem || !this.triagemItem.iD_TRIAGEM) {
      this.util.toasterShowError("Atenção", "Triagem não selecionada");
      return;
    }

    if (!this.arrayTipoClassificacao || this.arrayTipoClassificacao.length === 0) {
      this.util.toasterShowError("Atenção", "Nenhum tipo de classificação para salvar");
      return;
    }

    let dados = this.montarJsonSalvar();
    console.log("Dados para salvar:", dados);

    this.util.showLoading();
    let url = API + "TriagemParametro/TriagemParametro/SalvarLista";
    this.ajax.post(url, dados).subscribe(
      (response) => {
        console.log("Resposta do salvamento:", response);
        this.util.closeLoading();
        if (!response.hasErrors) {
          this.util.toasterShowSuccess("Atenção", "Parâmetros salvos com sucesso");
          this.voltar();
        } else {
          this.util.toasterShowError("Atenção", response.message || "Erro ao salvar parâmetros");
        }
      },
      (err) => {
        console.error("Erro ao salvar:", err);
        debugger;
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Salvar Parâmetros");
      }
    );
  }
}
